// import LanguagesDropdown from "../../LanguagesDropdown.js";
import ThemeSwitch from "../../ThemeSwitch";

const SettingsArea = () => {
  return (
    <>
      <ThemeSwitch />
      {/* <LanguagesDropdown /> */}
    </>
  );
};

export default SettingsArea;
